
// RL - Usar classes ES6, levar para arquivo externo
function IntegrationScope(scopeID, integrationID, scopeName, scopeValues) {
    this.ScopeID = scopeID;
    this.IntegrationID = integrationID;
    this.ScopeName = scopeName;
    this.ScopeValues = scopeValues;
}

function IntegrationMonitorService($resource, $routeParams, $http, $cacheFactory, $q, $filter, ToastService) {

    //--------------------------------------//
    //              Private                 //
    //--------------------------------------//

    var integrationList = [];
    var listIsLoaded = false;

    var baseUrl = '../Api/IntegrationMonitor';

    var serviceCache = $cacheFactory('IntegrationMonitorService');

    var res = $resource(baseUrl + 'Api/:id', {}, {
        list: { method: 'GET', isArray: true }, //cache: serviceCache
        getScopes: { method: 'GET', params: { id: 'id', skipNumber: '0', takeNumber: '10', errorOnly: false }, isArray: true },
        get: { method: 'GET', params: { id: 'id' }, isArray: false }, //cache: serviceCache
        save: { method: 'POST', params: { id: 'id' } },
        put: { method: 'PUT', params: { data: 'data' }, isArray: false },
        'delete': { method: 'DELETE', params: { id: 'id' }, isArray: false },
        deleteBatch: { method: 'DELETE', params: { ids: 'ids' }, isArray: false },
        //deleteBatch: {method: 'GET', params: {ids: 'ids'}, isArray: true},
        execute: { method: 'GET', params: { id: 'id' }, isArray: true },
        action: { method: 'GET', params: { id: 'id', actionTag: 'actionTag' }, isArray: false },
        enabledOnly: { method: 'GET', params: { enabledOnly: 'true' }, isArray: true },
        getList: { method: 'GET', params: { id: 'id', actionTag: 'actionTag' }, isArray: true }
    });

    //--------------------------------------//
    //                 Public               //
    //--------------------------------------//

    this.resetCache = function () {
        serviceCache.removeAll();
        integrationList = [];
    };

    this.postMethod = function (apiMethod, data, config) {
        return $http.post(baseUrl + apiMethod, data, config);
    };

    this.createNewScope = function (scopeID, integrationID, scopeName, scopeValues) {
        return new IntegrationScope(scopeID, integrationID, scopeName, scopeValues);
    };

    this.getIntegrationList = function () {

        return $q(function (resolve, reject) {

            var toastID = ToastService.createToast('', 'Carregando a lista de integrações', 0, 'wait');

            res.list(function (data) {
                resolve(data);
                listIsLoaded = true;
                ToastService.removeToast(toastID);

            }, function errorFunc(errorDescription) {
                ToastService.removeToast(toastID);
                ToastService.createToast('Erro ao carregar a lista de integrações', errorDescription, 8000, 'error');
                reject(errorDescription);
            });
        });
    };

    this.getIntegration = function (integrationID) {

        return $q(function (resolve, reject) {

            var toastID = ToastService.createToast('', 'Carregando a integração ' + integrationID, 0, 'wait');

            res.get({ id: integrationID }, function (data) {

                resolve(data);
                ToastService.removeToast(toastID);

            }, function errorFunc(errorDescription) {
                ToastService.removeToast(toastID);
                ToastService.createToast('Erro ao carregar a integração', errorDescription, 8000, 'error');
                reject(errorDescription);
            });
        });
    };

    this.getIntegrationScopes = function (integrationID, skipNumber, takeNumber, errorOnly) {
        return $q(function (resolve, reject) {

            var toastID = ToastService.createToast('', 'Carregando integração Queues', 0, 'wait');

            res.getScopes({ id: integrationID, skipNumber: skipNumber, takeNumber: takeNumber, errorOnly: errorOnly }, function (data) {

                resolve(data);
                ToastService.removeToast(toastID);
            }, function errorFunc(errorDescription) {
                ToastService.removeToast(toastID);
                ToastService.createToast('Erro ao carregar as queues', errorDescription, 8000, 'error');
                reject(errorDescription);
            });
        });
    };

    this.delete = function (id, callback)
    {
        return res.delete({ id: id }, callback);
    };

    this.isMonitoring = false;
    this.toggleMonitoring = function () {
        if (this.isMonitoring) {
            this.isMonitoring = false;
        }
        else {
            this.isMonitoring = true;
        }
    };

    this.getIntegrationRecents = function (filterString, options, skipNumber, takeNumber, sort) {
        //console.log('getShipOwners ' + skipNumber);
        return $http.put(baseUrl + '/GetIntegrationRecents',
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
            { cache: serviceCache }
        );
    };
    
}


seedWebServices.service('IntegrationMonitorService', ['$resource', '$routeParams', '$http', '$cacheFactory', '$q', '$filter', 'ToastService', IntegrationMonitorService]);